export default __webpack_public_path__ + "static/media/percorso-cavalieri.0f8da4a9.jpg";